import React from 'react';
import { withFirebase } from '../Firebase';
import FlightOptionsContext from "./flightOptionsContext";

const withFlightOptions = Component => {
    class WithFlightOptions extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                sortieDefaults: null,
                sortieEvents: null,
                tailNumbers: null,
                defaults: null,
                sortieTaskDefaults: null,
            };
        }

        componentDidMount() {
            this.props.firebase.sortieTaskDefaults().onSnapshot(doc => {
                if (doc.exists) {
                    this.setState({ sortieTaskDefaults: doc.data().subsections });
                }
            });

            this.props.firebase.sortieDefaults().onSnapshot(snapshot => {
                let sortieDefaults = {};
                snapshot.forEach(doc => {
                    sortieDefaults[doc.id] = doc.data();
                });
                this.setState({ sortieDefaults: sortieDefaults });
            });

            this.props.firebase.sortieEvents().onSnapshot(snapshot => {
                let sortieEvents = {};
                snapshot.forEach(doc => {
                    sortieEvents[doc.id] = doc.data();
                });
                this.setState({ sortieEvents: sortieEvents });
            });

            this.props.firebase.tailNumbers().onSnapshot(snapshot => {
                let tailNumbers = {};
                snapshot.forEach(doc => {
                    tailNumbers[doc.id] = doc.data();
                });
                this.setState({ tailNumbers: tailNumbers });
            });

            this.props.firebase.defaults().onSnapshot(snapshot => {
                let defaults = {};
                snapshot.forEach(doc => {
                    defaults[doc.id] = doc.data();
                });
                this.setState({ defaults: defaults });
            });
        }

        render() {
            const flightOptions = {
                sortieDefaults: this.state.sortieDefaults,
                sortieEvents: this.state.sortieEvents,
                tailNumbers: this.state.tailNumbers,
                defaults: this.state.defaults,
                sortieTaskDefaults: this.state.sortieTaskDefaults,
            }
            return (
                <FlightOptionsContext.Provider value={flightOptions}>
                    <Component {...this.props} />
                </FlightOptionsContext.Provider>
            );
        }
    }

    return withFirebase(WithFlightOptions);
};

export default withFlightOptions;
